import * as actionTypes from "../actions/discountActions";

const initialState = {
  relativeDiscount: 0,
  discountCode: "",
  discountAmount: null,
  isLoading: false,
  hasError: false,
  errorMessage: "",
};

const discountReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ADD_DISCOUNT:
      return {
        ...state,
        relativeDiscount: action.relativeDiscount,
        discountCode: action.discountCode,
      };
    case actionTypes.REMOVE_DISCOUNT:
      return {
        ...state,
        relativeDiscount: 0,
        discountCode: "",
      };
    case actionTypes.ADD_DISCOUNT_AMOUNT:
      return {
        ...state,
        discountAmount: action.payload.amount,
      };
    case actionTypes.SET_DISCOUNT_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case actionTypes.SET_DISCOUNT_ERROR:
      return {
        ...state,
        hasError: true,
        errorMessage: action.payload,
      };
    case actionTypes.CLEAR_DISCOUNT_ERROR:
      return {
        ...state,
        hasError: false,
        errorMessage: "",
      };
    case "CLEAR_DISCOUNT":
      return {
        ...state,
        discountCode: null,
        relativeDiscount: 0,
        discountAmount: null,
        isLoading: false,
      };

    default:
      return state;
  }
};

export default discountReducer;
